import { defineStore } from 'pinia'
const REQUEST_A_TRIAL = 'requestATrial'

const MODALS_AND_MENUS = {
  login: false,
  subscribe: false,
  newsletter: false,
  mobileMenu: false,
  mobileAccountMenu: false,
  updateRequest: false,
  changePassword: false,
  forgotPassword: false,
  accountMenu: false,
  requestATrial: false,
  imageLightbox: false,
  expiredTrial: false,
  renewMembership: false,
  noSourceSubscription: false,
  downloadSpecialIssue: false,
  createAccount: false,
  marketsOfInterest: false,
  newsletterPreferences: false,
  hubspotMeetingScheduler: false,
  contactForm: false,
  impersonating: false,
}

type State = {
  imageSrc: string
  loginRedirectionPath: string | null
  currentModule: keyof typeof MODULES
  [key: string]: boolean | string | null
}

export const useModalStore = defineStore('modal-store', {
  state: (): State => {
    return {
      imageSrc: '',
      loginRedirectionPath: null,
      currentModule: null,
      ...MODALS_AND_MENUS,
    }
  },

  actions: {
    open(modal: string, imageSrc?: string) {
      this[modal] = true

      for (const _modal in MODALS_AND_MENUS)
        if (_modal !== modal) this.close(_modal)

      this.loginRedirectionPath = null
      if (imageSrc) {
        this.imageSrc = imageSrc
      }
    },

    close(modal: string) {
      this[modal] = false
      this.imageSrc = ''
    },

    toggle(modal: string) {
      this[modal] = !this[modal]
    },

    reset() {
      for (const _modal in MODALS_AND_MENUS) this.close(_modal)
      this.loginRedirectionPath = null
    },

    isRequestATrialActive() {
      return this[REQUEST_A_TRIAL] === true
    },

    getModal(modalName: string) {
      return this[modalName] === true
    },
  },

  getters: {
    getImageSrc: (state) => state.imageSrc,
  },
})
